export default __webpack_public_path__ + "static/GreenBG-933e1ed40d15f9600d35193291776b1d.png";